<template>
  <!-- 最新文件 政策法规 -->
  <div id="newFilesD" class="listStyle">
    <!-- 点击弹出搜索弹框 -->
    <div @click="showSearchPopup = true" class="openPopup" id="goToHere">
      <van-sticky offset-top="2.24rem">
        <div class="location-png">
          <van-image width="13px" height="17px" :src="locationPng"/>
        </div>
        <van-cell
          v-if="valueC !== null && valueC !== ''"
          :title="'当前城市：' + valueP + '/' + valueC"
          style="font-size: 12px"
          is-link
          value="切换到其他省/市"
        />
        <van-cell
          v-else-if="valueP !== null && valueP !== '' && valueC === null"
          :title="'当前城市：' + valueP"
          style="font-size: 12px"
          is-link
          value="切换到其他省/市"
        />
         <van-cell
          v-else
          title="点击重新定位"
          style="font-size: 12px"
          is-link
          value="切换到其他省/市"
        />
      </van-sticky>
    </div>
    <div class="top">
      <!-- 法规分类 -->
      <!-- @initData="initTree" -->
      <classification-rules
        ref="classification"
        @showGetData="showGetData"
        @changeTagid="changeTagid"
        @getTree="getTree"
        :classifytag="data"
        :stime="stime"
        :etime="etime"
        :searchText="searchText"
      ></classification-rules>
      <!-- 法规层级 -->
      <regulations-hierarchy ref="regulations"></regulations-hierarchy>
      <!-- 搜索框 -->
      <!-- :newSearchText="newSearchText" -->
      <SearchBox
        ref="searchBox"
        @searchKeyWord="searchKeyWord"
        @selectTime="selectTime"
        @clearTime="clearTime"
        @changePotence="changePotence"
        placehold="当前区域适用法规查询"
      ></SearchBox>

      <!-- 城市切换弹框 -->
      <van-popup
        v-model="showSearchPopup"
        position="top"
        :style="{ height: '100%' }"
      >
        <div class="selectNavS">
          <van-area
            title="城市切换"
            :area-list="areaList"
            :columns-num="3"
            :visible-item-count="13"
            :value="
              valueC !== '' && valueCityCode !== ''
                ? valueCityCode
                : valueProvCode
            "
            @confirm="clickConfirmWord"
            @cancel="clickCancelWord"
          />
        </div>
      </van-popup>
      <!-- 搜索导航 -->
      <div v-if="classifyresult.length" class="classify-nav-box">
        <div
          v-for="(item, index) in classifyresult"
          :key="index"
          class="classify-nav-item"
        >
          <span class="classify-nav-content">
            {{ item }}
          </span>
          <!-- <span class="sanjiao"></span> -->
        </div>
      </div>
      <!-- 列表组件 -->
      <list-content
        ref="listContent"
        :updateDatas="updateDatas"
        :provinceLists="provinceLists"
        :cityLists="cityLists"
        :globalLists="globalLists"
        :place="place"
        @changeCityFlag="changeCityFlag"
        @changeProvinceFlag="changeProvinceFlag"
        @changeGlobalFlag="changeGlobalFlag"
        :totalLists="totalLists"
        :totalLists1="totalLists1"
        :totalLists2="totalLists2"
      ></list-content>
      <!-- 一键上传 -->
      <upload-file ref="uploadFile"></upload-file>
    </div>
    <div style="height: 0.001rem"></div>
    <!-- 分页 -->
    <!-- 全国 -->
    <div v-if="globalFlag && globalLists.length > 0" class="pageBoxStyle">
      <Pagination
        :currentPage="currentPage"
        :total="total"
        :totalLists="totalLists"
        @prevPage="prevPage"
        @nextPage="nextPage"
        @jumpToPageSize="jumpToPageSize"
      ></Pagination>
    </div>
    <!-- 省份 -->
    <div v-if="provinceFlag && provinceLists.length > 0" class="pageBoxStyle">
      <Pagination
        :currentPage="currentPage1"
        :total="total1"
        :totalLists="totalLists1"
        @prevPage="prevPage1"
        @nextPage="nextPage1"
        @jumpToPageSize="jumpToPageSize1"
      ></Pagination>
    </div>
    <!-- 城市 -->
    <div v-if="cityFlag && cityLists.length > 0" class="pageBoxStyle">
      <Pagination
        :currentPage="currentPage2"
        :total="total2"
        :totalLists="totalLists2"
        @prevPage="prevPage2"
        @nextPage="nextPage2"
        @jumpToPageSize="jumpToPageSize2"
      ></Pagination>
    </div>
    <!-- 底部导航 -->
    <tabbar
      ref="tabbar"
      :upSuccess="upSuccess"
      @alertBars="alertBars"
      @alertCengji="alertCengji"
      @updateOrDelete="updateOrDelete"
      @chooseUpdateOrDelete="chooseUpdateOrDelete"
      :selectedID="selectedId"
    ></tabbar>
    <van-overlay :showLoding="showLoding"></van-overlay>
  </div>
</template>

<script>
import SearchBox from "@/components/common/search";
import Tabbar from "@/components/common/tabbar";

import ClassificationRules from "@/components/common/classificationRules"; // 法规分类
import RegulationsHierarchy from "@/components/common/regulationsHierarchy"; // 法规层级
import UploadFile from "@/components/common/uploadFile"; // 一键上传
import ListContent from "@/components/common/listContent";
import VanOverlay from "@/components/common/vanOverlay";
import Vue from "vue";
import Pagination from "@/components/common/pagination"; // 分页

import { searchToObj } from "@/utils/lib/searchtoobj";
import { sortclassify } from "@/utils/newLibs/sortclassify";
import { warningNotify } from "../../utils/lib/toast";

export default {
  data() {
    return {
      showLoding: false,
      pp: "", // 定位的省份
      cc: "", // 默认选中定位的城市
      selectedId: "a",
      currentPage: 1, // 全国
      currentPage1: 1, // 省份
      currentPage2: 1, // 城市
      total: 0, // 全国
      total1: 0, // 省份
      total2: 0, // 城市
      totalLists: 0,
      totalLists1: 0,
      totalLists2: 0,
      lists: [], // 列表的数据
      classifytag: [], // 搜索下拉列表
      data: {},
      showNav: false, // 显示法规分类弹框
      minback: 0,
      minlock: 0,
      flag: false, // 数据返回后再加载组件
      stime: "", // 开始时间
      etime: "", // 结束时间
      searchText: "", // 搜索关键字
      tagid: "",
      showData: {},
      updateDatas: {},
      showSearchPopup: false, // 切换城市弹框
      provinceLists: [], // 省份
      cityLists: [], // 城市
      globalLists: [], // 全国
      place: true, // 显示列表的标记
      cityFlag: false,
      provinceFlag: false,
      globalFlag: true,
      areaList: {}, // 城市选择
      province: {},
      city: {},
      SearchTimes: 1,
      isFilter: false,
      classifyresult: [],
      potence: "",
      locationPng: require("../../assets/index/dizhi.png"),
      upSuccess: false //上传成功标志
    };
  },
  components: {
    SearchBox,
    Tabbar,
    ClassificationRules,
    RegulationsHierarchy,
    UploadFile,
    ListContent,
    VanOverlay,
    Pagination,
  },
  computed: {
    userId() {
      return this.$store.state.user.userId;
    },
    changeFlag() {
      // 切换全国版 true 与地方版 false
      return this.$store.state.changeVersion.changeFlag;
    },
    valueP() {
      return this.$store.state.commonSearchData.valueP;
    },
    valueC() {
      return this.$store.state.commonSearchData.valueC;
    },
    valueProvCode() {
      return this.$store.state.commonSearchData.valueProvCode;
    },
    valueCityCode() {
      return this.$store.state.commonSearchData.valueCityCode;
    },
    changeActivePlace() {
      return this.$store.state.commonSearchData.activePlace;
    },
    phone() {
      return this.$store.state.user.mobileNum;
    },
    maxopennum() {
      return this.$store.state.user.maxopennum;
    },
    // newSearchText() {
    //   // 切换全国版 true 与地方版 false
    //   return this.$store.state.changeSomeThing.newSearchText;
    // },
  },
  created() {
    if (this.userId) {
      this.$http.reqCreateDefault().then((res) => {
        console.log(res);
      });
    }
    if (
      location.search.includes("code") &&
      !sessionStorage.getItem("wxunionid") &&
     sessionStorage.getItem("userId")
    ) {
      console.log("关联微信路由变化===>", this.$router);
      let obj = searchToObj(location.search);
      //console.log("关联微信====>", obj);
      this.$http
        .reqPostWeixinUserBind(obj)
        .then((res) => {
          console.log("用户关联微信已经发送接口res====>", res);
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              this.$notify({
                type: "success",
                message: "关联微信成功",
                duration: 5000,
              });
              this.$http
                .refreshToken()
                .then((res) => {
                  this.bus.$emit("saveTokenHandle", res, 1);
                  this.getData();
                  this.getFixedFolder();
                  this.$router.push("/main");
                  return;
                })
                .catch((err) => {
                  console.log("用户关联微信刷新token err====>", err);
                });
            } else {
              this.$notify({
                message: res.rltdesc,
                duration: 5000,
              });
              this.getData();
              this.getFixedFolder();
            }
          } else {
            this.$notify({
              message: res.rtndesc,
              duration: 5000,
            });
          }
        })
        .catch((err) => {
          console.log("用户关联微信已经发送接口====>", err);
        });
    } else if (
      !location.search.includes("code") &&
     sessionStorage.getItem("userId")
    ) {
      this.updateClearData();
      this.getData();
      this.getFixedFolder();
    } else {
      this.updateClearData();
      this.getData();
    }
    this.reqGetProvinceAndCity();
    // +++
  },
  mounted() {
    this.bus.$on("replayNews", () => {
      this.updateClearData();
      console.log("replayNewFile");
      this.$refs.classification.clearTagId();
      this.$refs.searchBox.clearPotence();
      this.potence = "";
      this.tagid = "";
      this.clearMsg();
      this.getData(this.tagid, this.stime, this.etime, this.searchText, true);
      this.getTree({
        tagid: "",
        stime: "",
        etime: "",
        searchText: "",
      });
    });
    // this.$store.commit('commonSearchData/changeActivePlace', 0)
    console.log("changeActivePlace", this.changeActivePlace);
    this.pp = this.$store.state.commonSearchData.valueProvCode;
    this.cc = this.$store.state.commonSearchData.valueCityCode;
    // console.log('this.$store.state.commonSearchData', this.$store.state.commonSearchData)
    // if (
    //   this.valueC === "" &&
    //   this.valueCityCode === "" &&
    //   this.valueP === "" &&
    //   this.valueProvCode === ""
    // ) {
    //   this.cityFlag = false;
    //   this.provinceFlag = false;
    //   this.globalFlag = true;
    // } else if (this.valueC === "" && this.valueCityCode === "") {
    //   this.cityFlag = false;
    //   this.provinceFlag = true;
    //   this.globalFlag = false;
    // } else {
    //   this.cityFlag = true;
    //   this.provinceFlag = false;
    //   this.globalFlag = false;
    // }
    if(this.$store.state.user.guidetimes>0){
      this.initStep();
      this.$store.state.user.guidetimes--;
    }
    
  },
  methods: {
    initStep() {
            this.$intro().setOptions({
            prevLabel:"返回",
            nextLabel:"下一步",
            doneLabel:"结束",
            skipLabel:"跳过",
            overlayOpacity:"0.7",
            showStepNumbers:true,
            stepNumbersOfLabel:"/",
            showBullets:false,
            showProgress:false,
            exitOnOverlayClick:false,
            showProgress:true,
            // tooltipClass:"customTooltip",
            steps: [{
                  intro: '<div style="text-align:center;font-size:15px;">欢迎使用众智云擎法规查询引导</div>'
              },{
                element: document.querySelector('.userBGTitle'),
                intro: '<div style="text-align:center;">点击“用户ID”展开<br /><b style="color:yellow">账号设置</b>,账号设置包含：<br /><b style="color:lightblue">账号中心、重置密码、更换手机<br />关联微信、修改密码</b> 等功能',
                position: 'right'
              },{
                element: document.querySelector('.tab-choose'),
                intro: '<div style="text-align:center;"><b style="color:yellow">系统导航栏</b><br />点击右侧箭头可以 <b style="color:lightblue">展开/收缩</b> 导航栏</div>',
                position: 'right'
              },{
                element: document.querySelector('#goToHere'),
                intro: '<div style="text-align:center;">选择 <b style="color:yellow">政策法规区域</b>（省 / 市）<br />切换显示对应省 / 市的政策法规检索结果</div>',
                position: 'right'
              },{
                element: document.querySelector('#search'),
                intro: '<div style="text-align:center;">在当前区域下进行 <b style="color:yellow">关键字检索</b> <br /> <b style="color:lightblue">"如需要查询2023年财会1号文件"</b> <br />则输入：财会 2023 1 <br /></div>',
                position: 'right'
              },{
                element: document.querySelector('.potence-box'),
                intro: '<div style="text-align:center;"><b style="color:yellow"> 文件效力选择器 </b><br />切换文件效力可缩小检索结果</div>',
                position: 'right'
              },{
                element: document.querySelector('.time-sanjiao'),
                intro: '<div style="text-align:center;"><b style="color:yellow"> 时间范围选择器 </b><br />可将检索结果缩小至所选时间范围之内</div>',
                position: 'right'
              },{
                element: document.querySelector('.van-tabbar--fixed'),
                intro: '<div style="text-align:center;">检索结果功能控制区包含：<br /><b style="color:yellow">法规分类</b>、<b style="color:yellow">一键上传</b>、<b style="color:yellow">选择上传</b><br />法规分类：切换类别（10大类,585小类）<br />一键上传：检索结果法规全量上传至云端<br />选择上传：检索结果法规选择上传至云端<br /></div>',
                position: 'top'
              }]
            }).start();
        },
    // 清除时间和搜索框的内容
    clearMsg() {
      this.$refs.searchBox.clearMsg();
    },
    // 点击城市选择的取消按钮
    clickCancelWord() {
      this.showSearchPopup = false;
    },
    // 点击城市选择的确定按钮
    clickConfirmWord(data) {
      console.log("data------->888888888888", data);
      if (data[0] != undefined) {
        if (this.changeActivePlace === 0) {
          // 判断显示分页
          this.cityFlag = true;
          this.provinceFlag = false;
          this.globalFlag = false;
        } else if (this.changeActivePlace === 1) {
          this.cityFlag = false;
          this.provinceFlag = true;
          this.globalFlag = false;
        } else if (this.changeActivePlace === 2) {
          this.cityFlag = false;
          this.provinceFlag = false;
          this.globalFlag = true;
        }

        this.SearchTimes = 1;
        this.province = {};
        this.city = {};
        this.clearProOrCityMsg();
        this.tagid = "";
        this.potence = "";
        this.clearMsg();
        this.stime = "";
        this.etime = "";
        this.searchText = "";
        this.$refs.searchBox.clearPotence();
        this.$refs.classification.clearTagId();
        this.showSearchPopup = false;
        this.province = data[0];
        this.$store.commit("commonSearchData/changeValueP", this.province.name);
        this.$store.commit(
          "commonSearchData/changeValueProvCode",
          this.province.code
        );

        if (data[1] !== undefined && data[2] === undefined) {
          this.city = data[1];
          this.$store.commit("commonSearchData/changeValueC", this.city.name);
          this.$store.commit(
            "commonSearchData/changeValueCityCode",
            this.city.code
          );
        }

        if (data[2] !== undefined) {
          this.city = data[2];
          this.$store.commit("commonSearchData/changeValueC", this.city.name);
          this.$store.commit(
            "commonSearchData/changeValueCityCode",
            this.city.code
          );
        }

        // this.alertBars1();
        this.backStatus();
        this.$refs.listContent.toggle([]);
        this.getData(this.tagid, this.stime, this.etime, this.searchText, true);
        this.getTree({
          tagid: "",
          stime: "",
          etime: "",
          searchText: "",
        });
      } else {
        this.showSearchPopup = false;
      }
    },
    // 获取省市的数据
    reqGetProvinceAndCity() {
      this.$http
        .reqGetProvinceAndCity()
        .then((res) => {
          if (res.rtncode === 1) {
            if (res.rltcode === 1) {
              // this.$store.dispatch(
              //   "commonSearchData/updateProvinceAndCity",
              //   res.datas
              // );
              let provinceAndCitylists = {
                province_list: {},
                city_list: {
                  110100: "北京",
                  120100: "天津",
                  310100: "上海",
                  500100: "重庆",
                },
                county_list: {},
              };
              res.datas.map((item) => {
                provinceAndCitylists.province_list[item.id] = item.label;
                if (item.id === "110000") {
                  if (item.children && item.children.length > 0) {
                    item.children.forEach((item) => {
                      provinceAndCitylists.county_list[item.id] = item.label;
                    });
                  }
                }
                if (item.id === "120000") {
                  if (item.children && item.children.length > 0) {
                    item.children.map((item) => {
                      provinceAndCitylists.county_list[item.id] = item.label;
                    });
                  }
                }
                if (item.id === "310000") {
                  if (item.children && item.children.length > 0) {
                    item.children.map((item) => {
                      provinceAndCitylists.county_list[item.id] = item.label;
                    });
                  }
                }
                if (item.id === "500000") {
                  if (item.children && item.children.length > 0) {
                    item.children.map((item) => {
                      provinceAndCitylists.county_list[item.id] = item.label;
                    });
                  }
                }
                if (
                  item.id !== "110000" &&
                  item.id !== "120000" &&
                  item.id !== "310000" &&
                  item.id !== "500000" &&
                  item.children &&
                  item.children.length > 0
                ) {
                  item.children.map((item) => {
                    provinceAndCitylists.city_list[item.id] = item.label;
                  });
                }
              });
              this.areaList = provinceAndCitylists;
              this.$store.dispatch(
                "commonSearchData/updateProvinceAndCity",
                this.areaList
              );
            }
          }
        })
        .catch((err) => {
          console.log("获取城市数据失败", err);
        });
    },
    // 清除数据
    clearProOrCityMsg() {
      this.currentPage = 1;
      this.currentPage1 = 1;
      this.currentPage2 = 1;
    },
    // 修改标杆信息
    changeCityFlag() {
      this.cityFlag = true;
      this.provinceFlag = false;
      this.globalFlag = false;
      this.backStatus();
      this.$refs.listContent.toggle([]);
    },
    changeProvinceFlag() {
      this.cityFlag = false;
      this.provinceFlag = true;
      this.globalFlag = false;
      this.backStatus();
      this.$refs.listContent.toggle([]);
    },
    changeGlobalFlag() {
      this.cityFlag = false;
      this.provinceFlag = false;
      this.globalFlag = true;
      this.backStatus();
      this.$refs.listContent.toggle([]);
    },
    // 获取/请求地方版默认数据
    getData(tagid, stime, etime, text, cityOrTimeChange = false) {
      this.showLoding = true;
      let nodes = Vue.prototype.$baseConfig.code;
      let args = {
        searchtimes: this.SearchTimes, // 查询次数，第一次查询一定传1，二次查询传2
        frist: {
          text:
            this.searchText && this.searchText !== "" ? this.searchText : "",
          potence: this.potence ? this.potence : "",
          icode: "",
          tcode: "",
          kcode: "",
          country: "",
          ps: {
            p: this.$store.state.commonSearchData.valueProvCode,
            c: this.$store.state.commonSearchData.valueCityCode,
            t: "",
          },
          dirid: "", // 上传目录ID，云端查询需要这个参数
          id: this.tagid && this.tagid !== "" ? this.tagid : "",
          stime: this.stime && this.stime !== "" ? this.stime : "",
          etime: this.etime && this.etime !== "" ? this.etime : "",
        },
        second: [],
        fliter: {
          isfilter: this.isFilter,
          tagpc: [
            { p: "000000", c: "000000" },
            {
              p: this.$store.state.commonSearchData.valueProvCode,
              c: "000000",
            },
            {
              p: this.$store.state.commonSearchData.valueProvCode,
              c: this.$store.state.commonSearchData.valueCityCode,
            },
          ],
          tagid: "",
        },
        pager: [
          { pagesize: 10, pageindex: this.currentPage }, // 全国
          { pagesize: 10, pageindex: this.currentPage1 }, // 省级
          { pagesize: 10, pageindex: this.currentPage2 }, // 市级
        ],
      };
      this.updateDatas = args;

      this.$http
        .reqGetLocalLastFiles(args, nodes)
        .then((response) => {
          if (response.rtncode === 1) {
            if (response.rltcode === 1) {
              console.log("地方版法规政策返回的数据", response);
              this.showLoding = false;
              this.globalLists =
                response.tbls[0].items !== null ? response.tbls[0].items : []; // 全国
              this.provinceLists =
                response.tbls[1].items !== null ? response.tbls[1].items : []; // 省份
              this.cityLists =
                response.tbls[2].items !== null ? response.tbls[2].items : []; // 城市

              this.total = Math.ceil(response.tbls[0].total / 10); // 全国
              this.total1 = Math.ceil(response.tbls[1].total / 10); // 省份
              this.total2 = Math.ceil(response.tbls[2].total / 10); // 城市

              this.totalLists = response.tbls[0].total; // 总的条数 全国
              this.totalLists1 = response.tbls[1].total; // 总的条数 省份
              this.totalLists2 = response.tbls[2].total; // 总的条数 城市

              if (cityOrTimeChange) {
                this.currentPage = 1;
                this.currentPage1 = 1;
                this.currentPage2 = 1;
                if (this.totalLists !== 0) {
                  this.$refs.listContent.changeTabsPlace(0);
                } else if (this.totalLists1 !== 0) {
                  this.$refs.listContent.changeTabsPlace(1);
                } else if (this.totalLists2 !== 0) {
                  this.$refs.listContent.changeTabsPlace(2);
                }
              }

              this.$store.commit(
                "search/setIsProtect",
                response.tbls[0].protect
              );
              this.$store.commit(
                "search/setWarningLevel",
                response.tbls[0].warninglevel
              );
              this.$store.commit(
                "search/setWarningText",
                response.tbls[0].warningtext
              );

              // this.classifytag = response.tbls[0].classifytag;
              // this.minback = response.tbls[0].minback;
              // this.minlock = response.tbls[0].minlock;
              this.place = true;
              // this.data = {
              //   classifytag: this.classifytag,
              //   minlock: this.minlock ? this.minlock : 0,
              // };

              this.$store.dispatch("choose/updateLists", this.lists);
              // this.bus.$emit("classifytagData", this.data);
            } else {
              warningNotify(response.rltdesc, this);
              this.showLoding = false;
            }
          } else {
            warningNotify(response.rtndesc, this);
            this.showLoding = false;
          }
        })
        .catch(() => {
          this.showLoding = false;
          // console.log('err====>2', err.message)
        });
    },

    getTree(data) {
      console.log("getTree START", data);

      this.showLoding = true;
      let args = {
        searchtimes: this.SearchTimes, // 查询次数，第一次查询一定传1，二次查询传2
        frist: {
          text: "",
          potence: "1",
          icode: "",
          tcode: "",
          kcode: "",
          country: "",
          ps: {
            p: this.$store.state.commonSearchData.valueProvCode,
            c: this.$store.state.commonSearchData.valueCityCode,
            t: "",
          },
          dirid: "", // 上传目录ID，云端查询需要这个参数
          id: data.tagid !== "" ? data.tagid : "",
          stime: "",
          etime: "",
        },
        second: [],
        fliter: {
          isfilter: false,
          tagpc: [
            { p: "000000", c: "000000" },
            {
              p: this.$store.state.commonSearchData.valueProvCode,
              c: "000000",
            },
            {
              p: this.$store.state.commonSearchData.valueProvCode,
              c: this.$store.state.commonSearchData.valueCityCode,
            },
          ],
          tagid: data.tagid !== "" ? data.tagid : "",
        },
        pager: [
          {
            pagesize: 10, // 当前页
            pageindex: this.currentPage, // 每页显示的条数
          },
        ],
      };
      console.log("changeFilter===========", this.changeFilter);
      this.$http
        .reqGetLocalLastFiles(args)
        .then((response) => {
          if (response.rtncode === 1) {
            if (response.rltcode === 1) {
              if (
                response.tbls[0].items === null &&
                response.tbls[0].classifytag.length === 0
              ) {
                this.$refs.classification.alertBar2();
              }

              this.showLoding = false;

              this.classifytag = response.tbls[0].classifytag;
              this.minback = response.tbls[0].minback;
              this.minlock = response.tbls[0].minlock;
              this.flag = true;
              this.data = {
                classifytag: this.classifytag,
                minlock: this.minlock ? this.minlock : 0,
              };

              this.bus.$emit("classifytagData", this.data);
            } else {
              warningNotify(response.rltdesc, this);
              this.showLoding = false;
            }
          } else {
            warningNotify(response.rtndesc, this);
            this.showLoding = false;
          }
        })
        .catch(() => {
          this.showLoding = false;
        });
    },
    // 改变页码  全国
    changePage(num) {
      this.currentPage = num;
      this.currentPage1 = 1;
      this.currentPage2 = 1;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere");
        dom.scrollIntoView();
      });
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
    },
    // 省份
    changePage1(num) {
      this.currentPage = 1;
      this.currentPage1 = num;
      this.currentPage2 = 1;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere");
        dom.scrollIntoView();
      });
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
    },
    // 城市
    changePage2(num) {
      this.currentPage = 1;
      this.currentPage1 = 1;
      this.currentPage2 = num;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere");
        dom.scrollIntoView();
      });
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
    },
    prevPage() {
      // 全国上一页
      if (this.currentPage == 1) return;
      this.currentPage1 = 1;
      this.currentPage2 = 1;
      this.currentPage--;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere");
        dom.scrollIntoView();
      });
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
    },
    nextPage() {
      // 下一页
      if (this.currentPage == this.total) return;
      this.currentPage1 = 1;
      this.currentPage2 = 1;
      this.currentPage++;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere");
        dom.scrollIntoView();
      });
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
    },
    jumpToPageSize(num) {
      // 跳转到多少页
      this.currentPage = num;
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
    },
    prevPage1() {
      // 省份上一页
      if (this.currentPage1 == 1) return;
      this.currentPage = 1;
      this.currentPage2 = 1;
      this.currentPage1--;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere");
        dom.scrollIntoView();
      });
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
    },
    nextPage1() {
      // 下一页
      if (this.currentPage1 == this.total1) return;
      this.currentPage = 1;
      this.currentPage2 = 1;
      this.currentPage1++;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere");
        dom.scrollIntoView();
      });
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
    },
    jumpToPageSize1(num) {
      // 跳转到多少页
      this.currentPage1 = num;
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
    },
    prevPage2() {
      // 城市上一页
      if (this.currentPage2 == 1) return;
      this.currentPage = 1;
      this.currentPage1 = 1;
      this.currentPage2--;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere");
        dom.scrollIntoView();
      });
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
    },
    nextPage2() {
      // 下一页
      if (this.currentPage2 == this.total2) return;
      this.currentPage = 1;
      this.currentPage1 = 1;
      this.currentPage2++;
      this.$nextTick(() => {
        let dom = document.getElementById("goToHere");
        dom.scrollIntoView();
      });
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
    },
    jumpToPageSize2(num) {
      // 跳转到多少页
      this.currentPage2 = num;
      this.getData(this.tagid, this.stime, this.etime, this.searchText);
    },
    showGetData(data) {
      console.log("法规分类触发的事件data===>", data);
      this.showData = data;
      this.tagid = data.tagid;
      this.getData(this.tagid, data.stime, data.etime, data.searchText, true);
    },
    // 选择时间
    selectTime(time) {
      this.SearchTimes = 1;
      this.isFilter = false;
      // this.tagid = "";
      // this.$refs.classification.minlock = 0;
      this.stime = time.stime;
      this.etime = time.etime;
      this.currentPage = 1;
      this.getData(this.tagid, this.stime, this.etime, this.searchText, true);
      this.backStatus();
      this.$refs.listContent.toggle([]);
    },
    // 搜索按钮
    searchKeyWord(keyword) {
      // if (!(this.stime || this.etime || keyword)) {
      this.SearchTimes = 1;
      // } else {
      //   this.SearchTimes = 2;
      // }
      this.isFilter = false;
      // this.tagid = "";
      // this.$refs.classification.minlock = 0;
      this.searchText = keyword;

      this.currentPage = 1;
      this.getData(this.tagid, this.stime, this.etime, this.searchText, true);
      this.backStatus();
      this.$refs.listContent.toggle([]);
    },
    // 清除时间按钮
    clearTime() {
      // if (!this.searchText) {
      this.SearchTimes = 1;
      // } else {
      //   this.SearchTimes = 2;
      // }
      this.isFilter = false;
      // this.tagid = "";
      // this.$refs.classification.minlock = 0;
      this.stime = "";
      this.etime = "";
      this.currentPage = 1;
      this.getData(this.tagid, this.stime, this.etime, this.searchText, true);
      this.backStatus();
      this.$refs.listContent.toggle([]);
    },
    // 改变tagid的值
    changeTagid(val) {
      this.tagid = val;
      this.backStatus();
      this.$refs.listContent.toggle([]);
    },
    // 点击弹出搜索导航框 法规分类
    alertBars() {
      this.$refs.classification.alertBars();
    },
    // 清除数据
    alertBars1() {
      this.$refs.classification.alertBars1();
    },
    // 点击弹出法规层级框
    alertCengji() {
      this.$refs.regulations.alertCengji();
    },
    // 点击一键上传
    updateOrDelete() {
      // console.log('点击了地方版的一键上传的参数数据==》', this.updateDatas)
      let activePlace = this.$store.state.commonSearchData.activePlace;
      console.log(activePlace, this.valueCityCode, this.valueProvCode);
      if (this.userId) {
        if (
          activePlace === 0 &&
          this.valueC === "" &&
          this.valueCityCode === "" &&
          this.valueP === "" &&
          this.valueProvCode === ""
        ) {
          // 上传全国
          this.$refs.uploadFile.updateOrDelete(this.updateDatas, "上传全国");
        } else if (
          activePlace === 0 &&
          this.valueC === "" &&
          this.valueCityCode === "" &&
          this.valueP !== "" &&
          this.valueProvCode !== ""
        ) {
          // 上传省级
          this.$refs.uploadFile.updateOrDelete(this.updateDatas, "上传省级");
        } else if (
          activePlace === 1 &&
          this.valueC === "" &&
          this.valueCityCode === "" &&
          this.valueP !== "" &&
          this.valueProvCode !== ""
        ) {
          // 上传全国
          this.$refs.uploadFile.updateOrDelete(this.updateDatas, "上传全国");
        } else if (
          activePlace === 0 &&
          this.valueC !== "" &&
          this.valueCityCode !== "" &&
          this.valueP !== "" &&
          this.valueProvCode !== ""
        ) {
          // 上传城市
          this.$refs.uploadFile.updateOrDelete(this.updateDatas, "上传全国");
        } else if (
          activePlace === 1 &&
          this.valueC !== "" &&
          this.valueCityCode !== "" &&
          this.valueP !== "" &&
          this.valueProvCode !== ""
        ) {
          // 上传省级
          this.$refs.uploadFile.updateOrDelete(this.updateDatas, "上传省级");
        } else if (activePlace === 2) {
          // 上传全国
          this.$refs.uploadFile.updateOrDelete(this.updateDatas, "上传城市");
        }
      } else {
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: "请先登录",
          duration: 5000,
        });
      }
    },
    // 点击选择上传
    chooseUpdateOrDelete() {
      if (this.userId) {
        if (
          this.$store.state.choose.flag1 === false &&
          (this.globalLists.length > 0 ||
            this.provinceLists.length > 0 ||
            this.cityLists.length > 0) &&
          this.$store.state.choose.result.length === 0
        ) {
          this.$refs.listContent.changeFlag();
          this.$store.commit("choose/setFlag1", true);
          this.$store.commit("choose/setChooseUp1", "确定");
          this.$notify({
            color: "#fff",
            background: "#F27852",
            message: "请先选择要上传的文件",
            duration: 3000,
          });
        } else if (
          this.$store.state.choose.flag1 === true &&
          (this.globalLists.length > 0 ||
            this.provinceLists.length > 0 ||
            this.cityLists.length > 0) &&
          this.$store.state.choose.result.length === 0
        ) {
          this.backStatus();
          this.clearResult();
        } else if (
          this.$store.state.choose.flag1 === true &&
          (this.globalLists.length > 0 ||
            this.provinceLists.length > 0 ||
            this.cityLists.length > 0) &&
          this.$store.state.choose.result.length > 0
        ) {
          this.$refs.uploadFile.updateOrDelete(
            this.$store.state.choose.result,
            "选择上传"
          );
        }
      } else {
        this.$notify({
          color: "#fff",
          background: "#F27852",
          message: "请先登录",
        });
      }
    },
    // 恢复选择的状态
    backStatus() {
      this.$refs.listContent.changeFlag2();
      this.$store.commit("choose/setFlag1", false);
      this.$store.commit("choose/setChooseUp1", "选择上传");
      this.$store.commit("choose/setResult", []);
      this.upSuccess = true 
    },
    clearResult() {
      this.$refs.listContent.toggle([]);
    },
    // 清除数据
    clearArrayData() {
      this.provinceLists = []; // 省份
      this.cityLists = []; // 城市
      this.globalLists = []; // 全国
    },
    // 获取云端固定文件夹
    getFixedFolder() {
      this.$http.reqGetFixedFolder().then((response) => {
        //console.log("response.item登录成功后获取固定文件夹==>", response);
        if (response.rtncode === 1) {
          if (response.rltcode === 1) {
            this.$store.dispatch(
              "fixedFolder/updateFixedFolderArr",
              response.item
            );
            localStorage.setItem(
              "fixedFolderArr",
              JSON.stringify(response.item)
            );
          }
        }
      });
    },
    // 刷新清除数据
    updateClearData() {
      this.searchText = "";
      this.SearchTimes = 1;
      this.currentPage2 = 1;
      this.tagid = "";
      this.stime = "";
      this.etime = "";
      this.searchText = "";
      this.$store.commit(
        "commonSearchData/changeValueProvCode",
        localStorage.getItem("valueProvCode")
      );
      this.$store.commit(
        "commonSearchData/changeValueCityCode",
        localStorage.getItem("valueCityCode")
      );
      this.$store.commit(
        "commonSearchData/changeValueP",
        localStorage.getItem("valueP")
      );
      this.$store.commit(
        "commonSearchData/changeValueC",
        localStorage.getItem("valueC")
      );
    },
    changePotence(val) {
      this.clearProOrCityMsg();
      this.potence = val;
      this.getData(this.tagid, this.stime, this.etime, this.searchText, true);
    },
  },
  watch: {
    classifytag(newval, oldval) {
      // console.log(newval, oldval);
      this.classifyresult = [];
      if (this.minlock !== 0 && this.minlock !== undefined) {
        sortclassify(newval, this.classifyresult, this.minlock);
      }
      // console.log(this.classifyresult);
    },
  },
  destroyed() {
    this.$store.commit("choose/setFlag1", false);
    this.$store.commit("choose/setChooseUp1", "选择上传");
    this.$store.dispatch("choose/updateLists", []);
    this.$store.commit("choose/setResult", []);
    this.$store.commit("commonSearchData/changeActivePlace", 0);
    this.bus.$off("replayNews");
  },
};
</script>

<style lang="less" scoped>
#newFilesD {
  display: flex;
  flex-direction: column;
  .top {
    flex: 1;
    margin-bottom: 70px;
  }
  .selectNavS {
    padding: 20px 20px 20px;
  }
  /deep/.van-sticky {
    display: flex;
    align-items: center;
    background-color: white;
    .location-png {
      margin: 0 0px 0 18px;
    }
    .van-cell {
     padding-left: 5px;
    }
  }
  
}
.classify-nav-box {
  display: flex;
  padding: 0 6px;
  overflow-x: scroll;
  overflow-y: hidden;
  background-color: #fff;
  margin-bottom: 1px;

  // margin-bottom: 2px;
  .classify-nav-item {
    display: flex;
    align-items: center;
    .classify-nav-content {
      display: flex;
      padding: 0 0 0 6px;
      white-space: nowrap;
      height: 24px;
      font-size: 12px;
      color: #cb9728;
      line-height: 24px;
      background-color: #fff;
      &::after {
        margin-left: 4px;
        content: ">";
        color: #666;
        // border-top: 12px solid transparent;
        // border-left: 10px solid #fff;
        // border-bottom: 12px solid transparent;
        // filter: drop-shadow(6px 0px 4px rgba(0, 0, 0, 0.1));
      }
    }
    &:last-child {
      .classify-nav-content {
        &::after {
          content: "";
        }
      }
    }
    .sanjiao {
      margin-right: 4px;
      border-top: 10px solid transparent;
      border-left: 10px solid #fff;
      border-bottom: 10px solid transparent;
      filter: drop-shadow(2px 2px 10px rgba(0, 0, 0, 0.1));
    }
  }
}
</style>

<style>
.van-dropdown-item__content {
  max-height: 100%;
}
/* intro css */
.introjs-button{
  padding: .2rem 1rem;
}
.introjs-skipbutton{
  font-size: 0.34rem;
  color:rgb(179, 182, 174);
}
/* .openPopup {
  width: 84px;
} */
</style>
